import { render, staticRenderFns } from "./MarriageInputBirthdayPanel.vue?vue&type=template&id=3ee618ba&"
import script from "./MarriageInputBirthdayPanel.vue?vue&type=script&lang=js&"
export * from "./MarriageInputBirthdayPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports